import { Component, ElementRef, EventEmitter, Input, OnChanges,
         Output, SimpleChanges, ViewChild } from '@angular/core';

/** Regexp: accetta #RGB (3 cifre) e #RRGGBB (6 cifre) */
const HEX_RE = /^#[0-9A-Fa-f]{3}(?:[0-9A-Fa-f]{3})?$/;

/** Espande #RGB → #RRGGBB */
function expandHex(hex: string): string {
  if (/^#[0-9A-Fa-f]{3}$/.test(hex)) {
    const [, r, g, b] = hex;
    return `#${r}${r}${g}${g}${b}${b}`.toUpperCase();
  }
  return hex.toUpperCase();
}

@Component({
  selector: 'app-color-hex-input',
  templateUrl: './color-hex-input.component.html',
  standalone: false
})
export class ColorHexInputComponent implements OnChanges {
  @Input()  colore = '';
  @Output() coloreChange = new EventEmitter<string>();
  @Input()  label = 'Colore';
  @Input()  readonly = false;

  @ViewChild('nativePicker') pickerRef: ElementRef<HTMLInputElement>;

  /** Valore mostrato nel testo — aggiornato liberamente mentre si digita */
  displayValue = '';

  /** true se displayValue è un hex valido (#RGB o #RRGGBB) */
  get isValid(): boolean { return HEX_RE.test(this.displayValue); }

  /** Colore "sicuro" da usare come background: bianco se vuoto o non valido */
  get swatchColor(): string {
    return this.isValid ? expandHex(this.displayValue) : 'transparent';
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['colore']) {
      this.displayValue = changes['colore'].currentValue ?? '';
    }
  }

  // ── Digitazione manuale ───────────────────────────────────────────────────

  onTextInput(rawValue: string) {
    let v = (rawValue ?? '').trim();
    // Aggiunge il # automaticamente se l'utente digita senza
    if (v && !v.startsWith('#')) { v = '#' + v; }
    this.displayValue = v.toUpperCase();
    if (this.isValid) {
      this.emit(expandHex(this.displayValue));
    }
  }

  // ── Native color picker ───────────────────────────────────────────────────

  openPicker() {
    if (this.readonly) { return; }
    // Pre-imposta il picker sul valore corrente (o bianco)
    const safe = this.isValid ? expandHex(this.displayValue) : '#FFFFFF';
    this.pickerRef.nativeElement.value = safe.toLowerCase();
    this.pickerRef.nativeElement.click();
  }

  onPickerChange(event: Event) {
    const hex = (event.target as HTMLInputElement).value.toUpperCase();
    this.displayValue = hex;
    this.emit(hex);
  }

  // ── Reset ─────────────────────────────────────────────────────────────────

  reset() {
    this.displayValue = '';
    this.emit('');
  }

  // ─────────────────────────────────────────────────────────────────────────

  private emit(value: string) {
    this.colore = value;
    this.coloreChange.emit(value);
  }
}
